import React, { useState, useMemo, useContext } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18n-js'
import en from '../translations/en.json'
import th from '../translations/th.json'

i18n.fallbacks = true
i18n.translations = { th, en }

const LocalizationContext = React.createContext()

export function LocalizationProvider({ children }) {
  const [locale, setLocale] = useState('th')
  const localizationContext = useMemo(
    () => ({
      t: (scope, options) => i18n.t(scope, { locale, ...options }),
      locale,
      setLocale,
    }),
    [locale]
  )

  return (
    <LocalizationContext.Provider value={localizationContext}>
      {children}
    </LocalizationContext.Provider>
  )
}

export const useLocalization = () => {
  const context = useContext(LocalizationContext)
  if (!context) {
    throw new Error('useLocalization should be use in side auth context')
  }
  return context
}

LocalizationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}
